import { api } from "./api";

/**
 * Lightweight, anonymous funnel tracker for the landing page.
 *
 * - Each visitor gets a uuid `session_id` persisted in localStorage so events
 *   can be deduplicated server-side and chained into a real funnel
 * - Backend deduplicates per (session_id, event) — repeated events are dropped
 * - Errors are swallowed: tracking must NEVER break UX
 */
const SESSION_KEY = "prenotoo_landing_session_v1";

function getSessionId() {
  try {
    let id = localStorage.getItem(SESSION_KEY);
    if (id) return id;
    // Use crypto.randomUUID where available, otherwise fall back
    const uuid = (typeof crypto !== "undefined" && crypto.randomUUID)
      ? crypto.randomUUID()
      : `s-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
    localStorage.setItem(SESSION_KEY, uuid);
    return uuid;
  } catch {
    return `s-${Date.now()}`;
  }
}

const sentInThisTab = new Set();

export function trackLanding(event, meta) {
  // Local dedupe to avoid hitting the network for repeat events in the same tab
  const key = `${event}`;
  if (sentInThisTab.has(key)) return;
  sentInThisTab.add(key);
  const session_id = getSessionId();
  // Fire-and-forget; never throw
  api.post("/analytics/landing-event", { event, session_id, meta }).catch(() => {});
}
